import React from 'react';

export const VisaLogo = ({ className = "h-4" }) => (
  <svg className={className} viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="780" height="500" rx="40" fill="#1A1F71"/>
    <path d="M293.2 348.7l33.4-195.8h53.4l-33.4 195.8h-53.4zm224.1-191c-10.6-4-27.2-8.3-47.9-8.3-52.8 0-90 26.6-90.2 64.7-.3 28.2 26.5 43.9 46.8 53.3 20.8 9.6 27.8 15.8 27.7 24.4-.1 13.2-16.6 19.2-32 19.2-21.4 0-32.7-3-50.3-10.2l-6.9-3.1-7.5 43.9c12.5 5.5 35.6 10.2 59.6 10.5 56.2 0 92.6-26.3 93-67.1.2-22.4-14.1-39.4-45-53.4-18.7-9.1-30.2-15.2-30.1-24.4 0-8.2 9.7-16.9 30.7-16.9 17.5-.3 30.2 3.5 40.1 7.5l4.8 2.3 7.2-42.4zm139.4-4.8h-41.3c-12.8 0-22.4 3.5-28 16.3l-79.4 179.8h56.2s9.2-24.2 11.3-29.5h68.6c1.6 6.9 6.5 29.5 6.5 29.5h49.7l-43.6-196.1zm-65.8 126.4c4.4-11.3 21.4-54.8 21.4-54.8-.3.5 4.4-11.4 7.1-18.8l3.6 17s10.3 47 12.4 56.6h-44.5zM285.5 152.9l-52.4 133.6-5.6-27.1c-9.7-31.2-40-65-73.8-81.9l47.9 171h56.6l84.2-195.8h-56.9v.2z" fill="#fff"/>
    <path d="M146.9 152.9h-86l-.7 4c67.1 16.2 111.5 55.4 129.9 102.4l-18.7-90.1c-3.2-12.4-12.8-16-24.5-16.3z" fill="#F9A533"/>
  </svg>
);

export const MastercardLogo = ({ className = "h-4" }) => (
  <svg className={className} viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="780" height="500" rx="40" fill="#16366F"/>
    <circle cx="310" cy="250" r="150" fill="#EB001B"/>
    <circle cx="470" cy="250" r="150" fill="#F79E1B"/>
    <path d="M390 130.7c-37.5 29.8-61.5 75.6-61.5 127.3s24 97.5 61.5 127.3c37.5-29.8 61.5-75.6 61.5-127.3s-24-97.5-61.5-127.3z" fill="#FF5F00"/>
  </svg>
);

export const AmexLogo = ({ className = "h-4" }) => (
  <svg className={className} viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="780" height="500" rx="40" fill="#2E77BC"/>
    <text x="390" y="280" textAnchor="middle" fill="white" fontSize="120" fontFamily="Arial, sans-serif" fontWeight="bold">AMEX</text>
  </svg>
);

export const PayPalLogo = ({ className = "h-4" }) => (
  <svg className={className} viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="780" height="500" rx="40" fill="#fff" stroke="#ddd" strokeWidth="2"/>
    <path d="M377.8 166.1c-14.5-.9-30.4-.9-47.3-.9h-83.6c-7.6 0-14.1 5.3-15.3 12.8l-34.8 220.5c-.9 5.4 3.3 10.2 8.7 10.2h63.5c5.3 0 9.9-3.7 10.7-9l9.8-62.2c1.2-7.5 7.7-12.8 15.3-12.8h35.3c73.5 0 115.9-35.6 127-106.1 5-30.8.2-55-14.3-72-16-18.7-44.3-28.5-81.4-28.5h6.4z" fill="#003087"/>
    <path d="M458.4 272.8c-5.5 35.6-33 35.6-59.7 35.6h-15.2l10.6-67.4c.6-4.2 4.3-7.2 8.5-7.2h7c18.1 0 35.3 0 44.1 10.3 5.3 6.2 6.9 15.3 4.7 28.7z" fill="#003087"/>
    <path d="M560.2 166.1c-14.5-.9-30.4-.9-47.3-.9h-83.6c-7.6 0-14.1 5.3-15.3 12.8l-34.8 220.5c-.9 5.4 3.3 10.2 8.7 10.2h65c3.7 0 6.9-2.6 7.5-6.3l9.9-62.9c1.2-7.5 7.7-12.8 15.3-12.8h35.3c73.5 0 115.9-35.6 127-106.1 5-30.8.2-55-14.3-72-16-18.7-44.3-28.5-81.4-28.5h8z" fill="#0070E0"/>
    <path d="M640.8 272.8c-5.5 35.6-33 35.6-59.7 35.6h-15.2l10.6-67.4c.6-4.2 4.3-7.2 8.5-7.2h7c18.1 0 35.3 0 44.1 10.3 5.3 6.2 6.9 15.3 4.7 28.7z" fill="#0070E0"/>
  </svg>
);

export const AlphaBankLogo = ({ className = "h-4" }) => (
  <img src="/images/alpha-bank.png" alt="Alpha Bank" className={className + " object-contain"} />
);

export const PaymentMethodLogos = ({ size = "sm" }) => {
  const className = size === "sm" ? "h-4 w-auto" : "h-6 w-auto";
  return (
    <>
      <VisaLogo className={className} />
      <MastercardLogo className={className} />
      <AmexLogo className={className} />
      <PayPalLogo className={className} />
      <AlphaBankLogo className={className} />
    </>
  );
};
